import { jsx } from "@emotion/react";
import type { FC, HTMLProps, ReactHTML } from "react";

import * as styles from "./Spacer.styles";

const UNITS = {
  zero: "zero",
  quarter: "quarter",
  half: "half",
  one: "one",
  oneQuarter: "oneQuarter",
  oneHalf: "oneHalf",
  double: "double",
  doubleHalf: "doubleHalf",
  triple: "triple",
  tripleHalf: "tripleHalf",
  quad: "quad",
};

type UnitType = keyof typeof UNITS;

interface Props extends HTMLProps<HTMLDivElement> {
  /**
   * Specifies the width
   *
   * @default one
   */
  width?: UnitType;
  /**
   * Specifies the height
   *
   * @default none
   */
  height?: UnitType;
  /**
   * Type of html element the Spacer will be rendered as
   *
   * @default div
   */
  type?: keyof ReactHTML;
}

const Spacer: FC<Props> = ({ width, height, type, ...rest }: Props) => {
  const css = [
    styles.spacer,
    width && styles.width[width],
    height && styles.height[height],
    height && styles.heightDisplay,
  ];
  return jsx(type, { css, role: "separator", ...rest });
};

Spacer.defaultProps = {
  width: "one",
  type: "div",
};

export { Spacer, UNITS };
